import { noop } from 'lodash'
import { RefObject, useState } from 'react'

export interface UseAnchorProps {
  anchorRef: RefObject<HTMLDivElement | HTMLButtonElement | null>
  onClose?: () => void
  onOpen?: () => void
  onToggle?: () => void
}

/**
 * Hook to handle state for an anchored popover
 */
export function useAnchorRef({ anchorRef, onClose = noop, onOpen = noop }: UseAnchorProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLDivElement | HTMLButtonElement>(null)

  const handleOpen = () => {
    setAnchorEl(anchorRef.current)
    onOpen()
  }
  const handleClose = () => {
    setAnchorEl(null)
    onClose()
  }

  const handleToggle = () => {
    if (anchorEl) {
      setAnchorEl(null)
    } else {
      setAnchorEl(anchorRef.current)
    }
  }

  return {
    isOpen: !!anchorEl,
    anchorEl,
    open: handleOpen,
    close: handleClose,
    toggle: handleToggle,
  }
}
